module.exports = __webpack_public_path__ + "img/profile.ae5c7aa7.jpg";